import { createFileRoute } from "@tanstack/react-router";
import AdminFinance from "@/pages/admin/AdminFinance";

export const Route = createFileRoute("/admin/finanzas")({
  validateSearch: (search: Record<string, unknown>): { tab?: string | undefined } => ({
    tab: typeof search["tab"] === "string" ? (search["tab"] as string) : undefined,
  }),
  component: AdminFinance,
});
